
import { useMutation, useQuery } from "react-query";
import { EvaluationSectionService } from "./evaluationSectionService";

export const useCreateEvaluationSection = () =>
  useMutation({
    mutationFn: EvaluationSectionService.create,
  });

export const useEvaluationSections = () =>
  useQuery({
    queryKey: ["evaluation-sections"],
    queryFn: EvaluationSectionService.getAll,
  });

export const useUpdateEvaluationSection = () =>
  useMutation({
    mutationFn: ({ id, data }) => EvaluationSectionService.update(id, data),
  });

export const useDeleteEvaluationSection = () =>
  useMutation({
    mutationFn: (id) => EvaluationSectionService.remove(id),
  });
